/*
  Supported syntax:
  {
    appliesToCountries: [string] or string,
    itemsInCart: string, number or null,
    chosenPackage: string or null,
    tlds: array or null,
    testVersion: string or null,
    planChosenByCustomer: boolean or null,
    hasAnyAddonsInCart: boolean or null
  }

  appliesToCountries:
  Supports
    [country code]
    "all"

    examples:
    - appliesToCountries: ["ES", "NL"] will be applied when country code is "ES" or "NL", otherwise skipped
    - appliesToCountries: "all" will be applied for all country codes

  itemsInCart:
  Supports:
    less than X
    equals X
    greater than X

    examples:
     - less than 3 will match if items in cart is 1 or 2 (3 will fail)
     - greater than 3 will match if items in cart is 4 and up
     - equals is self explaining

  Full examples:

  {
    appliesToCountries: ["ES", "NL"],
    itemsInCart: "equals 1",
    chosenPackage: "PPS_SMALL",
    tlds: [".es", ".com"],
    testVersion: null,
    planChosenByCustomer: null,
    hasAnyAddonsInCart: null
  },
  {
    appliesToCountries: "all",
    itemsInCart: null,
    chosenPackage: null,
    tlds: null,
    testVersion: "B-0007",
    planChosenByCustomer: true,
    hasAnyAddonsInCart: false
  }

  Skip upsell step if add-on is in cart
  {
    appliesToCountries: "all",
    itemsInCart: "greater than 0",
    chosenPackage: null,
    tlds: null,
    testVersion: null,
    planChosenByCustomer: null,
    hasAnyAddonsInCart: true,
  },

*/

const getSkipPackageSelectPageSettings = () => [
  {
    appliesToCountries: ["ES"],
    itemsInCart: "equals 1",
    chosenPackage: "PPS_SMALL",
    tlds: null,
    testVersion: null,
    planChosenByCustomer: null,
    hasAnyAddonsInCart: null,
  },
  {
    appliesToCountries: "all",
    itemsInCart: "greater than 0",
    chosenPackage: null,
    tlds: null,
    testVersion: null,
    planChosenByCustomer: null,
    hasAnyAddonsInCart: true,
  },
];

export default getSkipPackageSelectPageSettings;
